import { Link } from "wouter";
import { useLocale } from "@/hooks/useLocale";
import { SUPPORTED_LOCALES, LOCALE_LABELS } from "@/lib/i18n/locales";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Languages, Check } from "lucide-react";

export function LanguageSwitcher() {
  const { locale, pathInLocale } = useLocale();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" title="Language">
          <Languages className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {SUPPORTED_LOCALES.map((loc) => (
          <DropdownMenuItem key={loc} asChild>
            <Link href={pathInLocale(loc)} className="flex items-center justify-between cursor-pointer">
              {LOCALE_LABELS[loc]}
              {loc === locale && <Check className="h-3.5 w-3.5 text-primary" />}
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
